webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(38);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(71);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(69);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueGoogleAutocomplete = __webpack_require__(68);
	
	var _vueGoogleAutocomplete2 = _interopRequireDefault(_vueGoogleAutocomplete);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  components: { VueGoogleAutocomplete: _vueGoogleAutocomplete2.default },
	  data: {
	    location: '',
	    address: '',
	    formatted_address: '',
	
	    geocode: {
	      lat: '',
	      long: ''
	    },
	
	    weather: {
	      temperature: '',
	      wind: '',
	      desc: '',
	      icon: ''
	    }
	  },
	
	  mounted: function mounted() {
	    this.$refs.address.focus();
	  },
	
	
	  methods: {
	    getAddressData: function getAddressData(addressData, placeResultData, id) {
	      this.location = addressData;
	      this.updateGeocode({ lat: addressData.latitude, long: addressData.longitude });
	      this.formatted_address = placeResultData.formatted_address;
	
	      this.lookupWeather();
	    },
	    updateGeocode: function updateGeocode(loc) {
	      if (!loc) {
	        this.geocode.lat = '';
	        this.geocode.long = '';
	      } else {
	        if ((0, _keys2.default)(loc).length > 1) {
	          if (loc.lat && loc.lat) {
	            this.geocode = loc;
	          }
	        }
	      }
	    },
	    clearWeather: function clearWeather() {
	      this.weather = {
	        temperature: '',
	        wind: '',
	        desc: '',
	        icon: ''
	      };
	    },
	    lookupWeather: function lookupWeather() {
	      var _this = this;
	
	      if (this.location && this.geocode.lat != '' && this.geocode.long != '') {
	        var api_link = 'https://cors-anywhere.herokuapp.com/https://api.darksky.net/forecast/0137b8413801ea36e9b83161b6793a17/' + this.geocode.lat + ',' + this.geocode.long + '?exclude=minutely,hourly,daily,alerts';
	
	
	        _axios2.default.create({
	          baseURL: window.location.origin,
	          responseType: 'json',
	          headers: {
	            "Access-Control-Allow-Origin": "*",
	            "Access-Control-Allow-Headers": "X-Requested-With, Content-Type",
	            "Content-Type": "application/json",
	            "dataType": "application/json"
	          }
	        });
	        _axios2.default.get(api_link).then(function (response) {
	          var forcast = response.data.currently;
	          _this.weather.temperature = Math.floor(forcast.temperature);
	          _this.weather.wind = Math.floor(forcast.windSpeed);
	          _this.weather.desc = forcast.summary.toLowerCase();
	          _this.weather.icon = forcast.icon.toLowerCase();
	        }).catch(function (error) {
	          _this.clearWeather();
	          console.log(error);
	        });
	      }
	    },
	    formatDesc: function formatDesc() {
	      var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if (str != '') {
	        str = str.toLowerCase().replace(/\b[a-z]/g, function (letter) {
	          return letter.toUpperCase();
	        });
	      }
	      return str;
	    },
	    weatherIcon: function weatherIcon() {
	      switch (this.weather.icon) {
	        case 'clear-day':
	          return 'wi-day-sunny';
	        case 'clear-night':
	          return 'wi-night-clear';
	        case 'cloudy':
	        case 'partly-cloudy-day':
	          return 'wi-cloudy';
	        case 'partly-cloudy-night':
	          return 'wi-night-partly-cloudy';
	        case 'fog':
	          return 'wi-fog';
	        case 'rain':
	          return 'wi-rain';
	        case 'sleet':
	          return 'wi-sleet';
	        case 'snow':
	          return 'wi-snow';
	        case 'wind':
	          return 'wi-windy';
	        default:
	          return 'wi-na';
	          break;
	      }
	    }
	  }
	});

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'VueGoogleAutocomplete',
	
	  props: {
	    id: {
	      type: String,
	      required: true
	    },
	
	    classname: String,
	
	    placeholder: {
	      type: String,
	      default: 'Start typing'
	    },
	
	    types: {
	      type: String,
	      default: 'address'
	    },
	
	    country: {
	      type: [String, Array],
	      default: null
	    },
	
	    enableGeolocation: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      autocomplete: null,
	
	      autocompleteText: ''
	    };
	  },
	
	  watch: {
	    autocompleteText: function autocompleteText(newVal, oldVal) {
	      this.$emit('inputChange', { newVal: newVal, oldVal: oldVal });
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var options = {};
	
	    if (this.types) {
	      options.types = [this.types];
	    }
	
	    if (this.country) {
	      options.componentRestrictions = {
	        country: this.country
	      };
	    }
	
	    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.id), options);
	
	    this.autocomplete.addListener('place_changed', function () {
	
	      var place = _this.autocomplete.getPlace();
	
	      if (!place.geometry) {
	        _this.$emit('no-results-found', place);
	        return;
	      }
	
	      var addressComponents = {
	        street_number: 'short_name',
	        route: 'long_name',
	        locality: 'long_name',
	        administrative_area_level_1: 'short_name',
	        country: 'long_name',
	        postal_code: 'short_name'
	      };
	
	      var returnData = {};
	
	      if (place.address_components !== undefined) {
	        for (var i = 0; i < place.address_components.length; i++) {
	          var addressType = place.address_components[i].types[0];
	
	          if (addressComponents[addressType]) {
	            var val = place.address_components[i][addressComponents[addressType]];
	            returnData[addressType] = val;
	          }
	        }
	
	        returnData['latitude'] = place.geometry.location.lat();
	        returnData['longitude'] = place.geometry.location.lng();
	
	        _this.$emit('placechanged', returnData, place, _this.id);
	
	        _this.autocompleteText = document.getElementById(_this.id).value;
	        _this.onChange();
	      }
	    });
	  },
	
	  methods: {
	    onFocus: function onFocus() {
	      this.geolocate();
	      this.$emit('focus');
	    },
	    onBlur: function onBlur() {
	      this.$emit('blur');
	    },
	    onChange: function onChange() {
	      this.$emit('change', this.autocompleteText);
	    },
	    onKeyPress: function onKeyPress(event) {
	      this.$emit('keypress', event);
	    },
	    clear: function clear() {
	      this.autocompleteText = '';
	    },
	    focus: function focus() {
	      this.$refs.autocomplete.focus();
	    },
	    blur: function blur() {
	      this.$refs.autocomplete.blur();
	    },
	    update: function update(value) {
	      this.autocompleteText = value;
	    },
	    geolocate: function geolocate() {
	      var _this2 = this;
	
	      if (this.enableGeolocation) {
	        if (navigator.geolocation) {
	          navigator.geolocation.getCurrentPosition(function (position) {
	            var geolocation = {
	              lat: position.coords.latitude,
	              lng: position.coords.longitude
	            };
	            var circle = new google.maps.Circle({
	              center: geolocation,
	              radius: position.coords.accuracy
	            });
	            _this2.autocomplete.setBounds(circle.getBounds());
	          });
	        }
	      }
	    }
	  }
	};

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'app'
	};

/***/ }),

/***/ 65:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(17)(
	  /* script */
	  __webpack_require__(36),
	  /* template */
	  __webpack_require__(70),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(65)
	
	var Component = __webpack_require__(17)(
	  /* script */
	  __webpack_require__(37),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.autocompleteText),
	      expression: "autocompleteText"
	    }],
	    ref: "autocomplete",
	    class: _vm.classname,
	    attrs: {
	      "type": "text",
	      "id": _vm.id,
	      "placeholder": _vm.placeholder
	    },
	    domProps: {
	      "value": (_vm.autocompleteText)
	    },
	    on: {
	      "focus": function($event) {
	        _vm.onFocus()
	      },
	      "blur": function($event) {
	        _vm.onBlur()
	      },
	      "change": _vm.onChange,
	      "keypress": _vm.onKeyPress,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.autocompleteText = $event.target.value
	      }
	    }
	  })
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.d69b1b46daaba3a86a48.js